import { render } from "./MellonWebECRPaymentMethod.vue?vue&type=template&id=4cac72a9"
import script from "./MellonWebECRPaymentMethod.vue?vue&type=script&lang=js"
export * from "./MellonWebECRPaymentMethod.vue?vue&type=script&lang=js"

import "./MellonWebECRPaymentMethod.vue?vue&type=style&index=0&id=4cac72a9&lang=less"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__